import { useEffect } from 'react'
import { Spinner } from '~/shadcn/ui/spinner'
import { Text } from '~/@mid_ui/typography/Text'
import { useUser } from '~/@biz_account/useUser/useUser'
import { StepHeadline } from '~/@pages_onboarding/_onboarding-stepper/StepHeadline'

function IdentityVerificationSubmitted() {
  const { reloadUser } = useUser()

  useEffect(() => {
    const checkIdentitityStatusInterval = setInterval(reloadUser, 3000)

    return () => clearInterval(checkIdentitityStatusInterval)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <div className="flex flex-col gap-10">
      <StepHeadline headingText="Overte svoju identitu" />
      <div className="flex flex-col gap-10 items-center justify-center min-h-[30svh] w-full">
        <div className="flex flex-col items-center">
          <Spinner className="size-10 mb-4" />
          <Text className="text-center font-medium">
            Predávame si dáta s Veriff, chvíľku počkajte.
          </Text>
        </div>
      </div>
    </div>
  )
}

export { IdentityVerificationSubmitted }
